 <template>
  <section id="checkout">
    <div id="breadcrumbs">
      <div class="py-3">
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="alert alert-warning">
                Compras superiores a $599.00 no genera costo de envío (No aplica
                suscripciones)
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 mb-0 text-left">
              <router-link to="/">Home</router-link>
              <span class="mx-2 mb-0">/</span>
              <router-link to="/cart">Carrito</router-link>
              <span class="mx-2 mb-0">/</span>
              <strong class="text-black">Pago</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- #breadcrumbs -->
    <div class="site-section">
      <div class="container">
        <div class="row" v-if="!is_login">
          <div class="col-md-12">
            <div
              class="border p-4 rounded bg-info text-white font-weight-bold"
              role="alert"
            >
              Ya tienes cuenta?
              <a href="#" class="text-warning" v-b-modal.login-modal
                >Click aquí</a
              >
              para comprar
            </div>
          </div>
        </div>
        <!-- #row -->
        <div v-if="is_login" class="row">
          <div v-if="!showTotal" class="col-md-12 mb-5 mb-md-0">
            <AddressForm
              :showT="showTotal"
              @changeV="changeView"
              @update="updateAddress"
            ></AddressForm>
            <hr />
          </div>
          <!-- .col-md-7 -->
          <div class="col-12 col-sm-7 order-last order-sm-first">
            <!-- .row -->
            <div v-if="showTotal" class="row mb-5">
              <div class="col-12">
                <b-card title="Dirección de entrega" class="mb-2">
                  <b-card-text
                    >{{ addressData.street }}
                    {{ addressData.no_ext }}</b-card-text
                  >
                  <b-card-text
                    >{{ addressData.suburb }} {{ addressData.cp }}
                  </b-card-text>
                  <b-card-text>{{ addressData.municipality }}</b-card-text>
                  <b-card-text>{{ addressData.references }}</b-card-text>
                  <button
                    class="btn text-light"
                    style="
                      width: 80%;
                      min-height: 45px;
                      background: #aa0e47;
                      color: #fff;
                    "
                    @click="changeView(!showTotal)"
                  >
                    Seleccionar otra dirección
                  </button>
                </b-card>
                <b-card title="Datos de entrega" class="mt-5">
                  <p>
                    Ingresa el nombre completo de la persona que firmará de
                    recibido.
                  </p>
                  <b-input-group>
                    <b-input
                      v-model="receiver.name"
                      placeholder="Nombre de la persona que recibe"
                      class="w-100 mb-3 border-0"
                    ></b-input>
                    <small class="ml-0 pl-0 mt-2 text-center w-100"
                      >En caso de dejar en blanco se pondrá a nombre del
                      titular de la cuenta</small
                    >
                  </b-input-group>
                </b-card>
                <!-- aqui va el menu con tabs -->
                <div class="card mt-5 border-0 p-3 mb-5">
                  <h2 class="h3 mb-4 mt-3 text-black">
                    Selecciona el m&eacute;todo de pago
                  </h2>
                  <nav class="nav nav-pills nav-justified align-items-center">
                    <!-- Stripe -->
                    <a
                      type="button"
                      id="btnStripe"
                      class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5"
                      @click="paymentType(6)"
                      ><img
                        src="images/img_estilos/stripe.png"
                        alt="Stripe"
                        loading="lazy"
                        style="width: 85px; height: 40px; object-fit: contain"
                    /></a>
                    <!-- <a 
                      type="button"
                      id="btnOpenPay"
                      class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5" 
                      @click="paymentType(5)">
                      <img src="images/img_estilos/btnOpenPay.png" 
                      alt="Openpay"
                      loading="lazy"
                      style="width: 85px; height: 40px; object-fit:contain;">
                    </a> -->
                    <!-- <a
                      type="button"
                      class="nav-item nav-link btn btn-default"
                      @click="paymentType(2)"
                      ><img
                        src="images/img_estilos/boton transferencia.svg"
                        style="width: 90px; height: 55px"
                    /></a> -->
                    <!-- <a
                      type="button"
                      class="nav-item nav-link btn btn-default"
                      @click="paymentType(3)"
                      ><img
                        src="images/img_estilos/boton oxxo.svg"
                        style="width: 90px; height: 55px"
                    /></a> -->
                     <!--<a
                      type="button"
                      id="btnCards"
                      class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5"
                      @click="paymentType(1)"
                      ><img
                        src="images/img_estilos/btnCards.png"
                        alt="Cards"
                        loading="lazy"
                        style="width: 85px; height: 40px; object-fit:contain;"
                    /></a>-->
                    <!-- <a
                      type="button"
                      id="btnPaypal"
                      class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5"
                      @click="paymentType(4)"
                      ><img src="images/img_estilos/btnPaypal.png"
                      alt="Paypal"
                      loading="lazy"
                        style="width: 85px; height: 40px; object-fit:contain;"
                    /></a> -->
                  </nav>
                </div>
                <!-- end -->
                <!-- Conekta Card -->
                <div>
                  <!--<button class="btn btn-default" @click="paymentType(1)">Pago con tarjeta bancaria</button>-->
                  <div v-show="is_card">
                    <div class="py-2">
                      <p class="mb-0">
                        Realiza tu pago con cargo a tu tarjeta de
                        crédito/d&eacute;bito. Tu orden llegará de 10 a 20
                        días.
                      </p>
                      <h5 class="h5 mb-3 mt-3 text-black" v-show="is_card">
                        Datos de tarjeta
                      </h5>
                      <div id="card-container" class="p-2 border">
                        <div id="card-form" v-show="is_card">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              data-conekta="card[name]"
                              placeholder="Nombre de cuentahabiente"
                            />
                          </div>
                          <!-- .form-group -->

                          <div class="form-group"></div>
                          <!-- .form-group -->
                          <div class="form-group row">
                            <div class="col-md-9">
                              <input
                                type="text"
                                class="form-control"
                                data-conekta="card[number]"
                                placeholder="Número de tarjeta"
                              />
                            </div>
                            <div class="col-md-3">
                              <input
                                type="text"
                                class="form-control"
                                data-conekta="card[cvc]"
                                placeholder="CVC"
                              />
                            </div>
                          </div>
                          <!-- .form-group -->

                          <div class="form-group row">
                            <div class="col-md-6">
                              <select
                                id="exp_month"
                                class="form-control"
                                data-conekta="card[exp_month]"
                              >
                                <option value="0">
                                  .: Selecciona el mes :.
                                </option>
                                <option
                                  v-for="month in card_months"
                                  :value="month"
                                >
                                  {{ month }}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-6">
                              <select
                                id="exp_year"
                                class="form-control"
                                data-conekta="card[exp_year]"
                              >
                                <option value="0">
                                  .: Selecciona el año :.
                                </option>
                                <option
                                  v-for="year in card_years"
                                  :value="year"
                                >
                                  {{ year }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <!-- .form-group -->
                          <div class="form-group" v-if="total >= 1000">
                            <small class="text-left d-block" style="color:red;">Pago a meses solo a partir de $1000 </small>
                            <select
                              name="months_to_pay"
                              id="months_to_pay"
                              v-model="months"
                              class="form-control"
                            >
                              <option value="0">.: Pago a meses :.</option>
                              <option value="3">3 meses</option>
                              <option value="6">6 meses</option>
                              <option value="9">9 meses</option>
                            </select>
                          </div>
                          <!-- .form-group -->
                        </div>
                        <!-- .card-form -->
                      </div>
                      <!-- #card-container -->
                    </div>
                  </div>
                </div>
                <!-- Conekta Transfer -->
                <div>
                  <!-- <button class="btn btn-default" @click="paymentType(2)">Transferencia bancaria</button> -->
                  <div v-show="is_transfer">
                    <div class="py-2">
                      <p class="mb-0">
                        Realiza tu pago directo desde tu cuenta bancaria. Por
                        favor usa tu Número de Orden como referencia de pago.
                        Tu orden no ser&aacute; enviada hasta que que tu pago
                        sea confirmado.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Conekta Oxxo -->
                <div>
                  <!--<button class="btn btn-default" @click="paymentType(3)">Pago con OXXO</button>-->
                  <div v-show="is_oxxo">
                    <div class="py-2">
                      <p class="mb-0">
                        Realiza tu pago desde tu OXXO más cercano. Tu orden no
                        ser&aacute; enviad&aacute; hasta que tu pago sea
                        confirmado.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Paypal -->
                <div>
                  <!--<button class="btn btn-default" @click="paymentType(4)">Paypal</button>-->
                  <div v-show="is_paypal">
                    <Paypal 
                      :tempTokenPaypal=this.tempTokenPaypal
                      :addressData=this.addressData
                      :products=this.products
                      :codeCoupon="codeCoupon"
                      @statusLoading="changeStatusLoading($event)"
                      ></Paypal>
                  </div>
                </div>
                <!-- Stripe -->
                <div v-show="is_stripe" id="sripe-method">
                  <Stripe 
                      :key="componentKey"
                      :showForm="is_stripe"
                      :addressData=this.addressData
                      :products=this.products
                      :codeCoupon="codeCoupon"
                      @statusLoading="changeStatusLoading($event)"
                      ></Stripe>
                  <div class="py-2">
                    <p class="mb-0">
                    </p>
                  </div>
                  <!-- Stripe -->
                </div>
                <!-- OpenPay -->
                <div>
                  <div v-show="is_openpay">
                    <ul class="nav nav-tabs mx-3 mx-md-4" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link text-black openPay active" @click="setPaymentMethod(1)" data-toggle="tab" href="#tab-tarjetas" role="tab">Tarjetas</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link text-black openPay" @click="setPaymentMethod(2)" data-toggle="tab" href="#tab-efectivo" role="tab">Efectivo</a>
                      </li> 
                      <li class="nav-item">
                        <a class="nav-link text-black openPay" @click="setPaymentMethod(3)" data-toggle="tab" href="#tab-transferencias" role="tab">Transferencias interbancarias</a>
                      </li>
                    </ul><!-- Tab panes -->
                    <div class="tab-content px-3 px-md-4">
                      <div class="tab-pane active" id="tab-tarjetas" role="tabpanel">
                        <div class="pt-5 pb-1">
                          <div class="form" id="op_processCard">
                            <div class="row">
                              <div class="col-12">
                                <p class="pb-3 mb-sm-2 text-center text-muted">Acepta pagos de tarjetas de crédito y débito por medio de OpenPay</p>
                              </div>
                            </div>

                            <div class="col-12">
                                <a class="btn btn-info mb-5 py-2" data-toggle="collapse" href="#collapsePaymentMethodsInfo" role="button" aria-expanded="false" aria-controls="collapseExample">
                                Metodos de pago ↕
                                </a>
                            </div>

                            <div class="collapse" id="collapsePaymentMethodsInfo">
                              <div class="row">
                                <div class="col-12">
                                  <p class="mb-1 mb-sm-2 text-left">
                                    Tarjetas de Crédito
                                  </p>
                                  <div class="row mb-4 align-items-center">
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/visa.png" alt="Visa" class="img-responsive img-fluid" width="40px" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/masterCard.png" alt="MasterCard" class="img-responsive img-fluid" width="40px" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/carnet.png" alt="Carnet" class="img-responsive img-fluid" width="90px" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/americanExpress.png" alt="American Express" class="img-responsive img-fluid" width="35px" height="auto"></div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12">
                                  <p class="text-left">Tarjetas de Débito</p>
                                  <div class="row mb-4 align-items-center">
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/hsbc.jpeg" alt="HSBC" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/scotiabank.png" alt="Scotiabank" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/citibanamex.png" alt="Citibanamex" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/bbva.png" alt="BBVA" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/santander.png" alt="Santander" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/ixe.png" alt="Ixe" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/bancoAzteca.png" alt="Banco Azteca" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/inbursa.png" alt="Inbursa" class="img-responsive img-fluid" height="auto"></div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <p class="text-left">Tarjetas de crédito a meses sin intereses</p>
                                  <div class="row mb-4 align-items-center">
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/bbva.png" alt="BBVA" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/citibanamex.png" alt="Citibanamex" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/inbursa.png" alt="Inbursa" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/santander.png" alt="Santander" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_openPay/monex.png" alt="Grupo Financiero Monex" class="img-fluid" height="auto"></div>                  
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_openPay/afirme.png" alt="Afirme" class="img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_openPay/banorte.png" alt="Banorte" class="img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_openPay/banRegio.png" alt="BanRegio" class="img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/hsbc.jpeg" alt="HSBC" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/scotiabank.png" alt="Scotiabank" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/americanExpress.png" alt="American Express" class="img-responsive img-fluid" width="35px" height="auto"></div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <p class="text-left">Puntos Bancarios</p>
                                  <div class="row mb-4 align-items-center">
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/bbva.png" alt="BBVA" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/scotiabank.png" alt="Scotiabank" class="img-responsive img-fluid" height="auto"></div>
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/santander.png" alt="Santander" class="img-responsive img-fluid" height="auto"></div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <p class="text-left">Tarjetas de servicio</p>
                                  <div class="row mb-4 align-items-center">
                                    <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/upSivale.png" alt="Up SiVale" class="img-responsive img-fluid" height="auto"></div>
                                  </div>
                                </div>
                              </div>

                            </div>


                            <div class="form-group">
                              <input type="text" name="openpay_holder_name" id="openpay_holder_name" class="form-control" placeholder="Nombre en la tarjeta" data-openpay-card="holder_name">
                            </div>
                            <div class="form-row mb-3">
                              <div class="col-10">
                                <input type="text" maxlength="16" name="openpay_card_number" id="openpay_card_number" class="form-control" placeholder="Número de la tarjeta" data-openpay-card="card_number">
                              </div>
                              <div class="col-2">
                                <input type="text" name="openpay_card_cvv" maxlength="4" id="openpay_card_cvv" class="form-control" placeholder="***" data-openpay-card="cvv2">
                              </div>
                            </div>
                            <div class="form-row">
                              <div class="col-6">
                                <select name="openpay_card_month" id="openpay_card_month" data-openpay-card="expiration_month" class="form-control">
                                  <option value="0">.: Elige el mes :.</option>
                                  <option v-for="month in card_months" :value="month">{{ month }}</option>
                                </select>
                              </div>
                              <div class="col-6">
                                <select name="openpay_card_year" id="openpay_card_year" data-openpay-card="expiration_year" class="form-control">
                                  <option value="0">.: Selecciona el año :.</option>
                                  <option v-for="year in card_years" :value="year.toString().substr(-2)">{{ year }}</option>
                                </select>
                              </div>
                            </div>
                            <div class="form-group my-5" v-if="total >= 1000">
                              <small class="text-left d-block" style="color:red;">Pago a meses solo a partir de $1000 </small>
                              <select name="months_to_pay" id="months_to_pay" v-model="months" class="form-control"
                              >
                                <option value="0">.: Pago a meses :.</option>
                                <option value="3">3 meses</option>
                                <option value="6">6 meses</option>
                                <option value="9">9 meses</option>
                              </select>
                            </div>
							<p class="text-danger mt-5">Al finalizar tu compra se hara llegar una notificación para token de seguridad por 3dSecure</p>
                            <input type="hidden" data-openpay-card-address="line1" :value="addressData.street">
                            <input type="hidden" data-openpay-card-address="line2" :value="addressData.no_ext">
                            <input type="hidden" data-openpay-card-address="line3" :value="addressData.references">
                            <input type="hidden" data-openpay-card-address="postal_code" :value="addressData.cp">
                            <input type="hidden" data-openpay-card-address="city" :value="addressData.state">
                            <input type="hidden" data-openpay-card-address="state" :value="addressData.state">
                            <input type="hidden" data-openpay-card-address="country_code" value="MX">
                            <input type="hidden" name="device_token_id" >
                          </div><!-- .form -->
                        </div>
                      </div>
                      <div class="tab-pane" id="tab-efectivo" role="tabpanel">
                        <open-pay-paynet :api_url="api_url"
                          :products="products"
                          :addressData="addressData"
                          :receiver="receiver"
                          :codeCoupon="codeCoupon"
                          @updateStates="updateStateLoaderAndBtn">
                        </open-pay-paynet>
                      </div>
                      <div class="tab-pane" id="tab-transferencias" role="tabpanel">
                        <open-pay-spei :api_url="api_url"
                          :products="products"
                          :addressData="addressData"
                          :receiver="receiver"
                          :codeCoupon="codeCoupon"
                          @updateStates="updateStateLoaderAndBtn">
                        </open-pay-spei>
                      </div>
                    </div>
                  </div><!-- Openpay -->
                </div>

                   <div class="form-group pt-2" v-if="is_login">
                    <loading :active.sync="is_loading"></loading>

                    <!--<button
                      v-if="is_paypal"
                      @click="placeOrder"
                      :disabled="desactivar"
                      class="btn btn-success btn-lg py-3 btn-block"
                      id="paymentBtn">
                      Procede al pago
                    </button>  -->
                  </div>
              </div>
            </div>
          </div>
          <!-- .col-md-7 -->
          <div v-if="showTotal" class="col-12 col-sm-5 order-first order-sm-last mb-5">
            <div class="card mb-sm-0 mb-md-5">
              <div class="card-body">
                <div class="order-products-list">
                  <h3 class="mb-1">Orden</h3>
                  <table class="table border site-block-order-table my-2 text-left table-responsive-md">
                    <thead>
                      <th>Producto</th>
                      <th>Total</th>
                      <th v-if="descuentoPorProducto.length > 0">Desc.</th>
                    </thead>
                    <tbody>
                      <tr v-for="product in products">
                        <td>
                        {{ product.item_name }}<strong class="mx-2">x</strong>
                        {{ product.quantity }}
                        <ul
                          class="list-group list-group-flush"
                          v-if="product.delight">
                          <li class="list-group-item">
                            {{ product.delight.description }} ({{
                              product.quantity
                            }})
                          </li>
                        </ul>
                        </td>
                        <td>${{ priceProduct(product.price, product.quantity) }}</td>
                        <template v-if="descuentoPorProducto">
                          <template v-for="descProduct in descuentoPorProducto">
                            <td v-if="descProduct == product.id" class="text-left border border-left-0 border-right-0 text-danger" >
                              -${{ product.desc }}
                            </td>
                          </template>                          
                        </template>
                      </tr>
                      <tr v-if="originalPrice && descuentoPorProducto && discountApplied">
                        <td class="text-black font-weight-bold">
                          <strong>Total original</strong>
                        </td>
                        <td class="text-black font-weight-bold">
                          <strong>${{ parseInt(originalPrice) }}</strong>
                        </td>
                      </tr>
                      <tr v-if="descPesos">
                        <td class="text-black¿ font-weight-bold">
                          <strong>Descuento General</strong>
                        </td>
                        <td class="text-danger font-weight-bold">
                          <strong>- ${{ parseFloat(descPesos) }}</strong>
                        </td>
                      </tr>
                      <tr v-if="sent_cost">
                        <td class="text-black font-weight-bold">
                          <strong>Costo de envío</strong>
                        </td>
                        <td class="text-black font-weight-bold">
                          <strong>${{ sending_cost }}</strong>
                        </td>
                      </tr>
                      <tr v-if="sent_cost">
                        <td class="text-black font-weight-bold">
                          <strong>Orden Total</strong>
                        </td>
                        <td class="text-black font-weight-bold">
                          <strong>${{ parseFloat(total) + parseFloat(sending_cost) }}</strong>
                        </td>
                      </tr>
                      <tr v-else>
                        <td class="text-black font-weight-bold">
                          <strong>Orden Total</strong>
                        </td>
                        <td class="text-black font-weight-bold">
                          <strong>${{ parseFloat(total) }}</strong>
         
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>



            <div class="row mb-0 mb-md-5">
              <div class="col-md-12">
                <div v-if="!discountApplied" class="card p-2 py-4 px-4 mt-0">
                  <h4 class="h3 mb-3" id="titleCoupon">Código de cupón</h4>
                  <div class="input-group w-100 d-flex align-items-center couponContainer">
                    <input
                      type="text"
                      class="form-control couponInput border-0"
                      id="c_code"
                      placeholder="Código"
                      aria-label="Coupon Code"
                      aria-describedby="btnCode"
                      v-model="codeCoupon"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-primary btn-sm couponBtn"
                        type="button"
                        id="btnCode"
                        @click="verifyCoupon"
                        :disabled="disableInput">
                        {{ textBtnVerifyCode }}
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else class="p-3 py-4 px-4 border mt-0">
                  <img loading="lazy" class="discountImage" src="images/discount.png" alt="">
                  <h4 class="mb-3 titleCodeCoupon" id="titleCoupon">{{ messageCoupon }}</h4>
                  <div class="input-group w-100 d-flex align-items-center couponContainer p-3">
                    <h6 class="text-center d-inline mx-auto">Código canjeado: {{ codeCoupon }}</h6>
                  </div>
                </div>
                <!-- .p-3.border -->
              </div>
              <!-- .col-md-12 -->
            </div>



            
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .container -->
    </div>
    <!-- .site-section -->
  </section>
</template>

<script>
// @ is an alias to /src
//import axios from "axios"
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import AddressForm from "@/components/AddressForm.vue";
import OpenPayPaynet from '../components/Payment/OpenPayPaynet.vue';
import OpenPaySpei from '../components/Payment/OpenPaySpei.vue';
import Stripe from "@/components/Stripe/Stripe.vue";
import Paypal from "@/components/Paypal/Paypal.vue";
import Axios from 'axios';
const axios = require("axios");

export default {
  name: "checkout",
  components: {
    Loading,
    AddressForm,
    OpenPayPaynet,
    OpenPaySpei,
    Stripe,
    Paypal,
  },
  data() {
    return {
      form: {
        street: "",
        no_ext: "",
        suburb: "",
        municipality: "",
        state: "",
        cp: "",
        btw_streets: "",
        references: "",
        isEdit: false,
      },
      is_loading: false,
      desactivar: false,
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
      local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
      openpay_id: process.env.VUE_APP_OPENPAY_ID,
      openpay_key: process.env.VUE_APP_OPENPAY_APIKEY,
      is_sandbox_mode: process.env.VUE_APP_SANDBOX_MODE,
      is_login: false,
      userData: {},
      cardData: {
        card_name: "",
        card_number: "",
        card_cvv: "",
        card_exp: "",
      },
      products: [],
      subtotal: 0,
      total: 0,
      iva: 0,
      have_iva: false,
      is_stripe: false,
      is_card: false,
      is_transfer: false,
      is_paypal: false,
      is_oxxo: false,
      is_openpay: false,
      is_openpay_cards:true,
      is_openpay_paynet:false,
      is_openpay_spei:false,
      conekta_token: "",
      months: 0,
      addressData: {},
      sent_cost: false,
      sending_cost: 65,
      card_months: [],
      card_years: [],
      showTotal: false,
      receiver: {
        name: "",
      },
      openPayCustomerId: null,
      deviceSessionId: null,
      disableInput: true,
      codeCoupon:"",
      textBtnVerifyCode: "APLICAR",
      descPesos: "",
      originalPrice:"",
      originalProduct:null,
      descuentoPorProducto: [],
      totalPerProduct: 0,
      cantidadesConDescuento: [],
      discountApplied: false,
      messageCoupon: "",
      hasDelight: false,
      tempTokenPaypal: "",
      componentKey: 0,
    }
  },
  filters: {
    pesos: function (number) {
      return new Intl.NumberFormat("es-MX").format(number);
    },
  },
  mounted(){
    let openpay_script = document.createElement("script");
    openpay_script.setAttribute('src', 'https://js.openpay.mx/openpay.v1.min.js');
    document.head.appendChild(openpay_script);
    let openpay_data_script = document.createElement("script");
    openpay_data_script.setAttribute('src', 'https://js.openpay.mx/openpay-data.v1.min.js');
    document.head.appendChild(openpay_data_script);

  },
  created() {
    const script = document.createElement("script");
    script.src = "https://cdn.conekta.io/js/latest/conekta.js";
    script.async = true;
    document.body.appendChild(script);

    // Se verifica si el usuario esta logeado
    if ($cookies.isKey("utoken")) {
      this.is_login = true;
      axios({
        method: "GET",
        url: this.api_url + "/subscribers/" + $cookies.get("uidmmkg"),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          console.info("Se obtienen los datos de el usuario: ", response);
          this.userData = response.data;

          this.receiver.name =
            this.userData.name +
            " " +
            this.userData.lastname +
            " " +
            this.userData.surname;
        })
        .catch((error) => {
          console.info("Error al obtener los datos del usuario: ", response);
        });
    } else {
    }

    if(this.$route.params.serverCart){
      console.info("Se obtiene carrito de parametros de ruta", this.products);
      this.products = this.$route.params.serverCart;
    }else{
      this.loadServerCart();
      console.info("Se obtiene carrito desde el servidor", this.products);
    }

    if ($cookies.isKey("utoken")) {
      // Verificacion de token de paypal
      const queryString = window.location.href;
      console.log("url: ",  queryString);
      const myArray = queryString.split("session_id=");
      this.tempTokenPaypal = myArray[1];

      if(this.tempTokenPaypal !== undefined){
        console.info("token paypal: ", this.tempTokenPaypal);
        this.products = JSON.parse(localStorage.getItem('temporalProductsPaypal'));
        this.addressData = JSON.parse(localStorage.getItem('temporalAddressPaypal'));
        this.codeCoupon = JSON.parse(localStorage.getItem('temporalCodeCouponPaypal'));
        this.showTotal = true;
        this.is_paypal = true;
      }
    }

    // Se setean los meses y años para los inputs
    this.card_months = ["01","02","03","04","05","06","07","08","09","10","11","12",];
    this.card_years = [2022,2023,2024,2025,2026,2027,2028,2029,2030,2031,2032,2033];
    // this.verifySentCost();
  },
  watch: {
    is_stripe(newVal, oldVal){
      (newVal === false) ? document.querySelector("#btnStripe").classList.remove('activeTab') 
      : document.querySelector("#btnStripe").classList.add('activeTab');
      this.is_loading = true;
    },
    is_card(newVal, oldVal){
      (newVal === false) ? document.querySelector("#btnCards").classList.remove('activeTab') 
      : document.querySelector("#btnCards").classList.add('activeTab');
    },
    is_paypal(newVal, oldVal){
      (newVal === false) ? document.querySelector("#btnPaypal").classList.remove('activeTab') 
      : document.querySelector("#btnPaypal").classList.add('activeTab');
      this.is_loading = false;
    },
    is_openpay(newVal, oldVal){
      (newVal === false) ? document.querySelector("#btnOpenPay").classList.remove('activeTab') 
      : document.querySelector("#btnOpenPay").classList.add('activeTab');
    },
    codeCoupon(newVal, oldVal){
      (newVal.length === 0) ? this.disableInput = true : this.disableInput = false;
    },
    products(newVal, oldval){
      // Verifica un cambio en products y se ejecuta el verificar costo y actualizar orden
      if(newVal.length > 0){
        this.verifySentCost();
        this.updateOrder();
      }
      for (let i = 0; i < newVal.length; i++) {
        if(newVal[i].delight){
          this.hasDelight = true;
          this.total = this.total + newVal[i].delight.prices[0].price;
        }
      }
    }
  },
  methods: {
    changeStatusLoading(boolean){
      this.is_loading = boolean;
    },
    priceProduct(price, quantity){
      return this.totalPerProduct = price * quantity
    },
    verifySentCost: function(){
      axios({
        method: "POST",
        url: this.api_url + "/shipping-fee/verify",
        data: {
          items: this.products,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
      .then((response) => {
        console.info("No tiene costo de envio", response.data.fee);
        if (response.data.fee > 0) {
          console.info("Tiene costo de envio", response.data.fee);
          this.sent_cost = true;
          this.sending_cost = response.data.fee;
        }
      })
      .catch((error) => {
        // Se manda a llamar de nuevo por si la solicitud falla, ya que a veces se pierde, error 502 bad gateway
        this.verifySentCost();
        console.error("Error al verificar costo de envio", error);
      });
    },
    changeView: function (value) {
        window.dataLayer.push({
            'event': 'AgregandoInfodePago',
            'pageURL': this.$router.currentRoute.fullPath,
            'product': this.products,
        });
      this.showTotal = value;
        window.dataLayer.push({
            'event': 'checkout',
            'pageURL': this.$router.currentRoute.fullPath,
            'product': this.products,
        });
    },
    getdirections() {
      axios.get(this.url).then((data) => {
        this.directions = data.data;
        console.log("Obteniendo direcciones de el usuario", this.directions);
      });
    },
    updateAddress: function (value) {
      console.info("Actualizando direccion en Checkout", value);
      this.addressData = value;
    },
    placeOrder: function () {
      this.desactivar = true;
      this.is_loading = true;

      if (this.receiver.name.length === 0 || this.receiver.name === "") {
        this.receiver.name =
          this.userData.name +
          " " +
          this.userData.lastname +
          " " +
          this.userData.surname;
      }

      if (this.months == 0) {
        this.months = 1;
      }
      if (jQuery.isEmptyObject(this.addressData)) {
        this.desactivar = false;
        this.$snotify.warning(
          "Falta la dirección de envío. Selecciona o registra una dirección de envío"
        );
        this.is_loading = false;
        } else {
          if (this.is_stripe) {
            this.sendDataStripe();
          } else if (this.is_card) {
            this.sendDataConekta();
          } else if (this.is_oxxo) {
            this.sendDataOxxo();
          } else if (this.is_transfer) {
            this.sendDataDeposit();
          } else if (this.is_paypal) {
            this.sendDataPaypal();
          } else if (this.is_openpay){
            if(this.is_openpay_cards){
              this.sendDataOpenpay();
            }
            else if(this.is_openpay_paynet){
              // Ejecuta el tipo de pago en el hijo openPayPaynet.vue
              this.$emit('paynetMethod');
            }
            else if(this.is_openpay_spei){
              this.$emit('speiMethod');
            }
        }
      }
    },
    updateOrder: function () {
      var suma = 0;
      var tiene_costo = false;

      this.products.forEach(function (item) {
        suma += item.quantity * item.price;
        if (item.type_id === 2 || item.type_id === 3) {
          tiene_costo = false;
          // if (item.quantity % 4 === 0) {
          //   tiene_costo = false;
          // } else {
          //   tiene_costo = true;
          // }
        } else {
          tiene_costo = true;
        }
        // if (item.id > 1) {
        //   tiene_costo = true;
        //   if (item.quantity % 4 === 0) {
        //     tiene_costo = false;
        //   } else {
        //     tiene_costo = true;
        //   }
        // }

        // if (suma >= 599) {
        //   tiene_costo = false;
        // }
      });
      this.subtotal = suma;
      this.total = this.subtotal;
      // this.sent_cost = tiene_costo;
      // if (this.sent_cost) {
      //   this.total += this.sending_cost;
      // }
    },
    paymentType: function (type) {
      switch (type) {
        case 1:
          this.is_card = true;
          this.is_transfer = false;
          this.is_oxxo = false;
          this.is_paypal = false;
          this.is_openpay = false;
          this.is_stripe = false;
          break;

        case 2:
          this.is_card = false;
          this.is_transfer = true;
          this.is_oxxo = false;
          this.is_paypal = false;
          this.is_openpay = false;
          this.is_stripe = false;
          break;

        case 3:
          this.is_card = false;
          this.is_transfer = false;
          this.is_oxxo = true;
          this.is_paypal = false;
          this.is_openpay = false;
          this.is_stripe = false;
          break;

        case 4:
          this.is_card = false;
          this.is_transfer = false;
          this.is_oxxo = false;
          this.is_paypal = true;
          this.is_openpay = false;
          this.is_stripe = false;
          break;

        case 6:
          this.is_card = false;
          this.is_transfer = false;
          this.is_oxxo = false;
          this.is_paypal = false;
          this.is_openpay = false;
          this.is_stripe = true;
          break;

        default:
          this.is_card = false;
          this.is_transfer = false;
          this.is_oxxo = false;
          this.is_paypal = false;
          this.is_openpay = true;
          this.is_stripe = false;
          break;
      }
    },
    setPaymentMethod: function(type){
      switch (type){
        case 2:
          this.is_openpay_cards = false;
          this.is_openpay_paynet = true;
          this.is_openpay_spei = false;
          document.querySelector("#paymentBtn").innerHTML = 'Generar referencia de pago';
          break;

        case 3:
          this.is_openpay_cards = false;
          this.is_openpay_paynet = false;
          this.is_openpay_spei = true;
          document.querySelector("#paymentBtn").innerHTML = 'Generar referencia de pago';
          break;

        default:
          this.is_openpay_cards = true;
          this.is_openpay_paynet = false;
          this.is_openpay_spei = false;
          document.querySelector("#paymentBtn").innerHTML = 'Procede al pago';
          break;
      }
    },
    sendDataOxxo: function () {
      // Funcion para realizar el cargo por OXXO
      axios({
        method: "POST",
        url: this.api_url + "/payment/oxxo",
        data: {
          user_id: $cookies.get("uidmmkg"),
          items: this.products,
          address: this.addressData,
          receiver: this.receiver,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.desactivar = false;
          console.info("Respuesta de peticion pago Oxxo", response);
          if (response.data.data.response.status) {
            console.info("Redirigiendo a la pagina de la ficha");
            this.addToTagManager(this.products, "" , this.addressData, "El metodo de pago es Oxxo", new Date().toLocaleString('en-US'));

            this.$router.push({
              name: "thanksoxxo",
              params: {
                total: response.data.data.response[0].amount / 100,
                reference:
                  response.data.data.response[0].charges.data[0].payment_method
                    .reference,
                barcode:
                  response.data.data.response[0].charges.data[0].payment_method
                    .barcode_url,
              },
            });
          } else {
            this.desactivar = false;
            this.$snotify.error("Sucedió un error en la transacción");
          }
          this.is_loading = false;
        })
        .catch((error) => {
          console.error("Error en la peticion pago de Oxxo", error);
          this.desactivar = false;
          this.is_loading = false;
          this.$snotify.error(error);
        });
    },
    sendDataDeposit: function () {
      // Funcion para realizar el cargo por SPEI
      axios({
        method: "POST",
        url: this.api_url + "/payment/spei",
        data: {
          user_id: $cookies.get("uidmmkg"),
          items: this.products,
          address: this.addressData,
          receiver: this.receiver,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          console.info("Respuesta de peticion pago Deposito Spei", response);
          this.desactivar = false;
          if (response.status) {
            this.$snotify.success(
              "Se realizó el registro de la transacción correctamente"
            );
            console.info("Redirigiendo a la pagina de la ficha");
            this.addToTagManager(this.products, "" , this.addressData, "El metodo de pago es SPEI", new Date().toLocaleString('en-US'));

            this.$router.push({
              name: "thanksspei",
              params: {
                total: response.data.data.response[0].amount / 100,
                clabe:
                  response.data.data.response[0].charges.data[0].payment_method
                    .clabe,
                bank: response.data.data.response[0].charges.data[0]
                  .payment_method.bank,
              },
            });
          } else {
            this.desactivar = false;
            this.$snotify.error("Sucedió un error en la transacción");
          }
          this.is_loading = false;
        })
        .catch((error) => {
          this.desactivar = false;
          console.error("Respuesta de peticion pago Deposito Spei", error);
          this.is_loading = false;
          this.$snotify.error(error);
        });
    },
    sendDataStripe: function(){
        axios({
        method: "POST",
        url: this.api_url + "/payment/stripe/card",
        data: {
          user_id: $cookies.get("uidmmkg"),
          items: this.products,
          address: this.addressData,
          receiver: this.receiver,
          success_url: this.local_url + "/thanksStripe?session_id={CHECKOUT_SESSION_ID}",
          cancel_url: this.local_url,
          months: this.months,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {

          this.desactivar = false;
          console.info(response);
          if (response.data.status) {
            console.info("respuesta stripe: ", response.data);

            this.$store.commit('saveSeveralProducts', this.products);
            this.addToTagManager(this.products, "" , this.address, "El metodo de pago es Stripe", new Date().toLocaleString('en-US'));
            this.$snotify.info("Redirigiendo a Stripe");
            window.location.href = response.data.redirect_url;
          } else {
            this.$snotify.error(response.data.message);
          }
          this.is_loading = false;

        })
        .catch((error) => {
          console.error(error);
          this.desactivar = false;
          this.is_loading = false;
          this.$snotify.error(error);
        });
    },
    sendDataPaypal: function () {
      // Funcion para realizar el cargo a paypal
      axios({
        method: "POST",
        url: this.api_url + "/payment/paypal",
        data: {
          user_id: $cookies.get("uidmmkg"),
          items: this.products,
          address: this.addressData,
          receiver: this.receiver,
          success_url: this.local_url + "/thanks",
          cancel_url: this.local_url,
          code: this.codeCoupon,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.desactivar = false;
          console.info("Respuesta de peticion pago Paypal: ",response);
          if (response.status) {
            this.$store.commit('saveSeveralProducts', this.products);
            this.addToTagManager(this.products, "" , this.addressData, "El metodo de pago es Paypal", new Date().toLocaleString('en-US'));
            this.$snotify.info("Redirigiendo a Paypal");
            window.location.href = response.data.data.response.redirect_url;
          } else {
            this.$snotify.error("Sucedió un error en la transacción");
          }
          this.is_loading = false;
        })
        .catch((error) => {
          console.error("Error en la peticion de pago Paypal: ",error);
          this.desactivar = false;
          this.is_loading = false;
          this.$snotify.error(error);
        });
    },
    sendDataConekta: function () {
      // Funcion para realizar el cobro por tarjeta de credito o debito
      Conekta.setPublicKey(process.env.VUE_APP_CONEKTA_PUB_KEY);
      Conekta.setLanguage("es");
      var form = $("#card-form");
      Conekta.Token.create(form, this.successConekta, this.errorConekta);
    },
    successConekta: function (response) {
      this.conekta_token = response.id;
      if (this.months == "") {
        this.months = 0;
      }
      axios({
        method: "POST",
        url: this.api_url + "/payment/card",
        data: {
          user_id: $cookies.get("uidmmkg"),
          token: this.conekta_token,
          months: this.months,
          items: this.products,
          address: this.addressData,
          receiver: this.receiver,
          code: this.codeCoupon
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.desactivar = false;
          this.is_loading = false;
          console.info("Respuesta de peticion pago conekta: ",response);
          if (response.data.response.status) {
            this.addToTagManager(this.products, this.months, this.addressData, "El metodo de pago es por tarjetas de credito y debito conekta", new Date().toLocaleString('en-US'));
            this.$store.commit('saveSeveralProducts', this.products);
            this.$router.push({
              name: "thanks",
              query: { orden: response.data.paymentData.order },
            });
          } else {
            this.$snotify.warning(response.data.response.message);
          }
          this.is_loading = false;
        })
        .catch((error) => {
          console.error("Erron en la peticion de pago conekta: ",error);
          this.is_loading = false;
          this.desactivar = false;
          this.$snotify.error(error);
        });
    },
    errorConekta: function (response) {
      console.info("Error en la peticion de pago conekta:", response);
      this.$snotify.error(response.message_to_purchaser);
      this.is_loading = false;
      this.desactivar = false;
    },
    sendDataOpenpay: function(){
      this.desactivar = true;
      try{
        //OpenPay.setId('m0mglvvud0ziko006r1l');
        //OpenPay.setApiKey('pk_a4c364b0775f4d5f82ff8d11a0e33775');
          OpenPay.setId(this.openpay_id);
          OpenPay.setApiKey(this.openpay_key);
        this.deviceSessionId = OpenPay.deviceData.setup('op_processCard', 'deviceIdHiddenFieldName');
        console.info("Se crea deviceSessionId ",this.deviceSessionId);
        if(this.deviceSessionId === null || this.deviceSessionId === undefined || this.deviceSessionId === ""){
            this.is_loading = false;
            this.$snotify.error("Error al intentar hacer el pago");
        }
        OpenPay.setSandboxMode(this.is_sandbox_mode);
        if(!OpenPay.card.validateCardNumber($('#openpay_card_number').val())){
          this.$snotify.error("El número de tarjeta no es valido");
          this.is_loading = false;
          this.desactivar = false;
        } else if(!OpenPay.card.validateCVC($('#openpay_card_cvv').val())){
          this.$snotify.error("El código CVC no es valido");
          this.is_loading = false;
          this.desactivar = false;
        } else if(!OpenPay.card.validateCVC($('#openpay_card_cvv').val(), $('#openpay_card_number').val())){
          this.$snotify.error("El código CVC no es valido para la tarjeta ingresada");
          this.is_loading = false;
          this.desactivar = false;
        }else{
          OpenPay.token.extractFormAndCreate($('#op_processCard'), this.successOpenpay, this.errorOpenpay, this.openPayCustomerId);
        }
      }catch(error){
          this.$snotify.error("Error al intentar hacer el pago");
          console.error("Error al intentar hacer el pago por openpay tarjetas", error);
          this.desactivar = false;
          this.is_loading = false;
      }
    },
    successOpenpay: function(response){
      console.info("Respuesta correcta de Openpay", response);
      axios({
        method: 'POST',
        url: this.api_url + '/payment/openpayCard',
        data: {
          user_id: $cookies.get("uidmmkg"),
          token: response.data.id,
          months: this.months,
          items: this.products,
          address: this.addressData,
          receiver: this.receiver,
          deviceIdHiddenFieldName: this.deviceSessionId,
          redirect_url: this.local_url + "/thanksOpenpay",
          code: this.codeCoupon,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      }).then((response) => {
        console.info("respuesta de pago en servidor", response);
        this.addToTagManager(this.products, this.months , this.addressData, "El metodo de pago es por OpenPay Tarjetas", new Date().toLocaleString('en-US'));
        if(response.data.status){
          this.$store.commit('saveSeveralProducts', this.products);
          this.$snotify.info("Redirigiendo a Openpay");
          console.info(response.data.redirect_url);
          window.location.href = response.data.redirect_url;
        }else{
          this.$snotify.warning(response.data.message);
        }
        this.desactivar = false;
        this.is_loading = false;
      }).catch( (error) => {
          this.is_loading = false;
          this.desactivar = false;
          console.error("Error en la respuesta de pago de openpay tarjetas", error);
          this.$snotify.error(error);
      });
    },
    errorOpenpay: function(response){
      console.error("Error en validación de pago en Openpay tarjetas", response)
      this.$snotify.error(response.message);
      this.is_loading = false;
      this.desactivar = false;
    },
    updateStateLoaderAndBtn(loaderVal, btnVal){
      // Metodo escuchando una accion de el hijo openPayPaynet.vue
      this.is_loading = loaderVal;
      this.desactivar = btnVal;
    },
    addToTagManager: function(products, months, addressData, paymentMethod, datePayment){
            window.dataLayer.push({
              'event': 'Pago',
              'pageURL': this.$router.currentRoute.fullPath,
              'product': products,
              'months': months,
              'address': addressData,
              'paymentMethod': paymentMethod,
              'datePayment': datePayment
            });
    },
    verifyCoupon: function(){
      this.textBtnVerifyCode = "Validando";
    // Peticion para verificar el cupon
      axios({
      method: "GET",
      url: this.api_url + "/coupon/verify",
      data: {
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + $cookies.get("utoken"),
      },
      params:{
        code: this.codeCoupon
      }
    })
      .then((response) => {
        console.info("Respuesta al verificar cupon",response.data);
        if (response.data.status) {
          this.originalPrice = this.total;
          let resp = this.checkIfProductsContainsDesc(response.data);
          // se guardan productos con precios originales
            this.originalProduct = this.products;

            if(response.data.products[0] === 0){
              // Este descuento aplica para todo el carrito en general
              this.descPesos =response.data.discount;
              this.descPesos = (this.descPesos * this.total) / 100; 
              this.total = this.total - this.descPesos;
              this.$snotify.success("Este cupon es valido para tu carrito con un " + response.data.discount + "% de descuento.");
              this.messageCoupon = "Cupón aplicado con " + response.data.discount + "% de descuento."
              this.discountApplied = true;
            }else{
              // Este descuento aplica para ciertos productos
              if(resp > 0){
                // Si resp es > 0 se encuentran productos para hacer descuento
                this.descuentoPorProducto = response.data.products;
                this.messageCoupon = "Cupón aplicado con " + response.data.discount + "% de descuento."
                this.discountApplied = true;
                setTimeout(() => {
                  this.$snotify.success("Este cupon es valido para ciertos productos con un " + response.data.discount + "% de descuento");
                }, 700);
              }
              else{
                this.$snotify.info("No hay descuentos para estos productos con este codigo");
              }
            } 
        } else {
          this.$snotify.warning(response.data.message);
        }
        this.textBtnVerifyCode = "APLICAR";
      })
      .catch((error) => {
        console.error("Error en la validacion de cupon", error);
      });
      this.is_stripe = false;
      this.componentKey += 1;
      setTimeout(() => {
        this.is_stripe  = true;
      }, 700);
    },
    checkIfProductsContainsDesc: function(productsDesc){
       var iguales = 0;
       let arrayMaxLength = 0;
      // Se determina cual array es mas grande
       if(this.products.length > productsDesc.products.length){
          arrayMaxLength = this.products.length;
       }
       else{
          arrayMaxLength = productsDesc.products.length;
       }
      //  Se hace la comparacion de ids de productospara hacer los calculos
      for(var i=0;i<arrayMaxLength;i++)
      {
        for(var j=0;j<arrayMaxLength;j++)
        {
          if(this.products[i]){
            if(this.products[i].id==productsDesc.products[j]){
              console.log("products: ", this.products[i]);
              console.log(productsDesc.products[j]);
              this.cantidadesConDescuento.push(productsDesc.discount * (this.products[i].price * this.products[i].quantity) / 100);
              Object.assign(this.products[i], {desc: productsDesc.discount * (this.products[i].price * this.products[i].quantity) / 100 });
              this.total = this.total - this.products[i].desc;
              iguales++;
            }
          }
        }
      } 
      return iguales;
    },
    loadServerCart: function(){
      if($cookies.get("uidmmkg")){
        axios({
            method: "GET",
            url:
                this.api_url +
                "/cart/" +
                $cookies.get("uidmmkg") +
                "?v=" +
                Math.floor(Date.now() / 1000),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + $cookies.get("ctoken"),
            },
        })
        .then((response) => {
            if (response.data.status) {
                console.info("cargando carrito de el servidor", response.data.cart);
                let productsServer = [];
                // Se formatea la estructura de los datos similar a el de localStorage
                for (let i = 0; i < response.data.cart.length; i++) {
                    let data = {
                        id: response.data.cart[i].product.id,
                        is_recurrency: false,
                        attribute: response.data.cart[i].attribute,
                        delight: response.data.cart[i].delight,
                        item_description: response.data.cart[i].product.description,
                        item_name: response.data.cart[i].product.name,
                        price: response.data.cart[i].product.prices[0].price,
                        priceObj: response.data.cart[i].product.prices[0],
                        quantity: response.data.cart[i].quantity,
                        type_id: response.data.cart[i].product.product_type_id,
                    };
                    productsServer.push(data);
                    this.products = productsServer;
                }
            }
        })
        .catch((error) => {
            console.error("No se pudo obtener carrito",error);
        });
      }
    }
  },

  onEdit(data) {
    this.form = data;
    this.form.isEdit = true;
  },
};
</script>

<style scoped>
.alert-warning {
  color: #856404 !important;
  background-color: #fff3cd !important;
  border-color: #ffeeba !important;
}
a.openPay:hover{
  color:#000000;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #000000;
    background-color: #e1e1e1;
    border-color: #dee2e6 #dee2e6 #fff;
}
img{
    image-rendering:-webkit-optimize-contrast; /* Safari         */
    image-rendering:optimize-contrast;         /* CSS3 Proposed  */
    -ms-interpolation-mode:nearest-neighbor;   /* IE8+           */
}
.nav-item.activeTab{
    box-shadow: 0 5px 20px -7px rgb(0 0 0 / 90%) !important;
    top: -2px;
}
.input-group.couponContainer{
    max-width: 300px;
    margin: auto;
}
.input-group-append{
  width:100%;
  margin-left:0px;
}
.couponInput{
  width:100% !important;
}
.couponBtn{
  width:100% !important;
  opacity:1 !important;
}
.form-control:disabled, .form-control[readonly] {
    opacity: 0.7;
    border: none;
}
.discountImage{
  width: 50px;
  position: absolute;
  top: 0;
  left: 4%;
}
.titleCodeCoupon{
  background: -webkit-linear-gradient(#0462e2, #032258);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.card {
    background-color: ghostwhite;
    border: none;
}
</style>
